import {ref} from 'vue';

export function useClientOpsModal() {
    const nonParticipantValidationComment = ref('');

    const isClientOpsDialogVisible = ref(false);

    function handleShowDialog() {
        isClientOpsDialogVisible.value = !isClientOpsDialogVisible.value;
    }
    return {
        nonParticipantValidationComment,
        isClientOpsDialogVisible,
        handleShowDialog,
    };
}
